// While a song preview plays (song pages, cards, the countdown), a small "■ Stop" pill is always
// in reach; previews also end when you leave the page (App.tsx).
import { useEffect, useState } from "react";
import { existingRiverPlayer, stopPreview } from "./context";
import type { RiverPlayer } from "./player";

export function PreviewBar() {
  const [player, setPlayer] = useState<RiverPlayer | null>(null);
  const [, setTick] = useState(0);
  useEffect(() => {
    let off: (() => void) | undefined;
    let alive = true;
    // The player may be created later (first visit to a page that previews): look again now and then.
    const attach = () =>
      void existingRiverPlayer().then((p) => {
        if (!alive || !p || off) return;
        setPlayer(p);
        off = p.onChange(() => setTick((n) => n + 1));
      });
    attach();
    const id = setInterval(attach, 1000);
    return () => {
      alive = false;
      clearInterval(id);
      off?.();
    };
  }, []);
  if (!player?.previewing) return null;
  return (
    <button type="button" className="preview-bar" onClick={() => void stopPreview()} data-testid="preview-stop">
      ■ Stop preview
    </button>
  );
}
